var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("AlbumLegacySyncDialog", {
    attrs: { "dialog-visible": true, "school-list": _vm.schoolList },
    on: { close: _vm.closePage },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }